<template>
	<div>
		<TopNav activeIndex="PatentAll" />
		<!-- 搜索栏 -->
		<div class="search-box">
			<el-row>
				<div class="search-item1">
					<div class="item-con">
						<div class="item-con-tle">搜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;索：</div><el-input
							class="searchtxt" size='small' @input='searchInput' :clearable='true'
							placeholder="请输入专利号/专利名称/领域" suffix-icon="el-icon-search" v-model="searval1"></el-input>
						<div class="item-ts-tle">多项搜索用空格隔开</div>
					</div>
					<div class="item-con" v-if="false">
						<div class="item-con-tle">专利名称：</div><el-input size='small' @input='zlmcInput' :clearable='true'
							placeholder="请输入专利名称" suffix-icon="el-icon-search" v-model="searh_ly_val"></el-input>
					</div>
					<div class="item-con" v-if="false">
						<div class="item-con-tle">专利号：</div><el-input size='small' @input="zlhInput" :clearable='true'
							placeholder="支持多件，空格分隔" suffix-icon="el-icon-search" v-model="searh_zlh_val"></el-input>
					</div>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">专利类型：</div>
					<el-checkbox-group v-model="zlztcheckList" @change='zlztCheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">授权未缴费发明</el-checkbox>
						<el-checkbox label="2">下证发明</el-checkbox>
						<el-checkbox label="3">授权未缴费实用</el-checkbox>
						<el-checkbox label="4">下证实用</el-checkbox>
						<el-checkbox label="5">外观</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">申报状态：</div>
					<el-checkbox-group v-model="sbztcheckList" @change='sbztcheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">已报高企</el-checkbox>
						<el-checkbox label="2">未报高企</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">专利分类：</div>
					<el-checkbox-group v-model="zlflcheckList" @change='zlflcheckChange'>
						<el-checkbox label="1">实时</el-checkbox>
						<el-checkbox label="2">代售</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">预定状态：</div>
					<el-checkbox-group v-model="ydztcheckList" @change='ydztcheckChange'>
						<!-- <el-checkbox label="0">不限</el-checkbox> -->
						<el-checkbox label="1">待出售</el-checkbox>
						<el-checkbox label="4">已预定</el-checkbox>
						<el-checkbox label="3">我预定/排队的</el-checkbox>
						<!-- <el-checkbox label="4">我排队的</el-checkbox> -->
					</el-checkbox-group>
				</div>
			</el-row>
			<el-row>
				<div class="fw-item">
					<div class="item-con-tle">价格范围：</div>
					<el-input class="item-con-ipt" @input='zdjInput1' size='small' v-model="searh_zdj1_val"
						:clearable='true' type="number" placeholder="价格最低值"></el-input>-
					<el-input class="item-con-ipt" @input='zdjInput2' size='small' v-model="searh_zdj2_val"
						:clearable='true' type="number" placeholder="价格最高值"></el-input>
				</div>
			</el-row>
			<el-row>
				<div class="check-item">
					<div class="item-con-tle">操&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;作：</div>
					<!-- <el-button type="primary" size="small" icon="el-icon-folder-add">新增</el-button> -->
					<el-button type="primary" size="small" icon="el-icon-copy-document" plain
						@click='copyzl'>复制</el-button>
					<!-- <el-button type="danger" size="small" icon="el-icon-delete">删除</el-button> -->
					<!-- <el-button type="danger" size="small" icon="el-icon-delete">一键删除</el-button> -->
					<!-- <el-button type="warning" size="small" icon="el-icon-refresh">批量更新</el-button> -->
					<el-button type="primary" size="small" @click="exportexecl()" icon="el-icon-upload2">导出</el-button>
					<el-upload ref="upload" accept='.xls,.xlsx,.csv' :http-request='uploadelc' class="upload-demo" action="https://jsonplaceholder.typicode.com/uploadexlec	/" :multiple='false':limit="1" :on-error="onErrorFile" :on-success='onSuccessFile'>
						<el-button type="primary" size="small" icon="el-icon-download">导入</el-button>
					</el-upload>
					<el-button type="text" size="small"><el-link type="primary" href="https://zhuanliy.com/uploads/用户导入模板.xlsx" target="_blank">下载导入模板</el-link></el-button>
				</div>
			</el-row>
		</div>

		<!-- 内容 -->
		<div class="con-box">
			<div class="con-tle-box">
				<el-popover class="popover" placement="top-start" width="200" trigger="hover" content="搜索到的专利数量">
					<div slot="reference">搜索到的专利总数：<el-link>{{total}}</el-link></div>
				</el-popover>
				<el-popover style="margin-left: 15px;" class="popover" placement="top-start" width="200" trigger="hover"
					content="今日新增的专利数量">
					<div slot="reference">今日新增：<el-link>{{daytotal}}</el-link></div>
				</el-popover>
			</div>
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
				@selection-change="handleSelectionChange" @sort-change="handleSortChange" stripe>
				<el-table-column type="selection" width="45">
				</el-table-column>
				<el-table-column label="#" type='index' :index='getIndex' width="45">
					<!-- <template slot-scope="scope">
						<div>1</div>
					</template> -->
				</el-table-column>
				<el-table-column prop="" sortable label="专利信息" width="550">
					<template slot-scope="scope">
						<div class="con-zlxx">
							<div class="con-zlxx-1">
								<!-- 专利号： -->
								<el-tag type="success" style="margin-right: 8px;" v-if="scope.row.classtype == 1" size='small'>实时</el-tag>
								<el-tag type="warning" style="margin-right: 8px;" v-if="scope.row.classtype == 2" size='small'>代售</el-tag>
								<span class="code" @click="copytxt(scope.row.patentnum+ ' ' + scope.row.patentname+ ' ' + scope.row.paymenttime)">{{scope.row.patentnum}}</span>
								<span class="code-a"
									@click="copytxt(scope.row.patentnum+ ' ' + scope.row.patentname+ ' ' + scope.row.paymenttime)">{{scope.row.patentname}}</span>
							</div>
							<!-- <div class='con-zlxx-2'>
								专利名称：
								<span class="code" @click="copytxt(scope.row.patentname)">{{scope.row.patentname}}</span>
							</div> -->
							<div class='con-zlxx-3'>
								类型：
								<span v-if="scope.row.type == 1">授权未缴费发明</span>
								<span v-else-if="scope.row.type == 2">下证发明</span>
								<span v-else-if="scope.row.type == 3">授权未缴费实用</span>
								<span v-else-if="scope.row.type == 4">下证实用</span>
								<span v-else-if="scope.row.type == 5">外观</span>
							</div>
							<div class='con-zlxx-3' v-if="scope.row.area">
								领域：{{scope.row.area}}
							</div>
							<div class='con-zlxx-4'>
								<span style="margin-right: 10px;" v-if="scope.row.paymenttime">缴费日期：{{scope.row.paymenttime}}</span>
								<el-tag type="danger" v-if="scope.row.ifhigh == 1"
									size='small'>已报过</el-tag>
							</div>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="领域" prop="area" width="260" show-overflow-tooltip> -->
				<!-- <div>房屋建筑、税额</div> -->
				<!-- </el-table-column> -->
				<el-table-column label="备注" prop="remarks" width="300"></el-table-column>
				<el-table-column sortable="custom" label="转让裸价" align='center' prop="guideprice" width="120"></el-table-column>
				<!-- <el-table-column sortable label="天数" prop="clts" width="120"> -->
				<!-- <div>88</div> -->
				<!-- </el-table-column> -->
				<el-table-column label="状态" align='center' width="120">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.status == 1">待出售</el-tag>
						<el-tag type="danger" v-if="scope.row.status == 4">已预定</el-tag>
						<el-tag type="info" v-if="scope.row.status == 5">已售</el-tag>
						<el-tag type="info" v-if="scope.row.status == 6">待审核</el-tag>
					</template>
				</el-table-column>
				<el-table-column sortable label="预定人" align='center' show-overflow-tooltip>
					<template slot-scope="scope">
						<div style="font-size: 14px;">
							<div v-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position == 1">
								{{userinfo.nickname}}</div>
							<div v-else-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position != 1">
								平台</div>
							<div v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue > 0">平台</div>
							<div v-if="scope.row.patent.has_queue > 0">截至:{{scope.row.patent.self_endtime}}</div>
							<!-- <div v-if="scope.row.patent.has_queue > 1">[排队:{{scope.row.patent.has_queue - 1}}人]</div> -->
							
						</div>
					</template>
				</el-table-column>
				<el-table-column sortable label="排队状态" align='center' show-overflow-tooltip>
					<template slot-scope="scope">
						<div style="font-size: 14px;" v-if="scope.row.patent.has_queue > 1">
							当前排队:{{scope.row.patent.has_queue - 1}}人</div>
						<div style="font-size: 14px;"
							v-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position > 1">
							我排第{{scope.row.patent.self_queue_position - 1}}位</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="con-sqyd"
							v-if="scope.row.patent.self_queued && scope.row.status == 6">申请中</div>
						<div class="con-sqyd"
							v-else-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position == 1"
							@click="sqydShow(scope.row,1)">取消预定</div>
						<div class="con-sqyd"
							v-else-if="scope.row.patent.self_queued && scope.row.patent.self_queue_position != 1"
							@click="sqydShow(scope.row,2)">取消排队</div>
						<div class="con-sqyd" v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue == 0"
							@click="sqydShow(scope.row,3)">预定</div>
						<div class="con-sqyd" v-else-if="!scope.row.patent.self_queued && scope.row.patent.has_queue != 0"
							@click="sqydShow(scope.row,4)">排队</div>
						<div class="con-sqyd-a" v-if="scope.row.patent.self_queued && scope.row.status == 4" @click="showyysq(3,scope.row.patent.queue_id)">延长时间</div>
					</template>
				</el-table-column>
				<!-- {{ scope.row.date }} -->
			</el-table>
		</div>
		<!-- 
		:current-page="currentPage4" -->
		<!-- 延长预约 -->
		<el-dialog title="提示" :visible.sync="ycyydialogVisible" width="25%">
			<span>是否延长该条预约申请，延长1天！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="ycyydialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="ycyysq">确 定</el-button>
			</span>
		</el-dialog>
		<el-pagination class="data-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			background :page-sizes="[10, 20, 30, 40,50,100]" :page-size="pageSize" layout=" prev, pager, next,sizes"
			:total="total">
		</el-pagination>
		<!-- 预定弹出框 -->
		<el-dialog :title="yddiaTile" :visible.sync="yddialogVisible" width="40%">
			<div style="display: flex;">
				<i class="el-icon-warning" style="color: #e6a23c;font-size: 24px;margin-right: 10px;"></i>
				<div>
					【{{yddialogItem.patentnum}}】{{yddialogItem.patentname}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size='small' @click="closeydtc()">取 消</el-button>
				<el-button size='small' type="primary" @click="sqyd()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import TopNav from '../../components/TopNav.vue'
	import Jsondata from '../../../data/data.json'
	import patentApi from '@/api/patent'
	export default {
		components: {
			TopNav
		},
		data() {
			return {
				userinfo: '',
				searval1: "", //专利号/专利名称/领域
				searh_zlh_val: '', //专利号
				searh_ly_val: '', //领域
				searh_zdj1_val: '', //转让裸价1
				searh_zdj2_val: '', //转让裸价2
				zlztcheckList: [], //专利状态
				sbztcheckList: [], //是否已报高校
				zlflcheckList: [], //专利分类
				ydztcheckList: [],
				input1: '',
				tableData: [], //列表数据
				total: 0, //数据总条数
				page: 1, //当前页码
				pageSize: 10, //列表页数
				multipleSelection: [],
				yddialogVisible: false, //预定弹出框
				yddiaTile: '预定专利？', //预定弹出框标题
				yddialogItem: '', //预定弹出框内容
				ydCancelType: 0, //新增：取消类型（0=新增，1=取消预订，2=取消排队）
				daytotal: 0,
				ycyydialogVisible:false,//延迟预约申请框
				tyjjyyid:'',//同意延长预约id
				sort_field: '', //排序字段
				sort_order: '', //排序方向

			};
		},
		created: function() {
			//加载专利
			this.loadPatentList();
			this.userinfo = JSON.parse(this.$store.state.userinfo);
		},
		methods: {
			showyysq(type,showid){
				this.tyjjyyid = showid;
				this.ycyydialogVisible = true;
			},
			ycyysq(){
				var that = this;
				patentApi.ycyypatent({
					id: that.tyjjyyid,
				}).then(res => {
					that.ycyydialogVisible = false;
					// that.showlsyydialog();
					that.tyjjyyid = '';
					this.loadPatentList();
				})
			},
			// 自定义上传
			uploadelc(file){
				const formData = new FormData();
				formData.append('file',file.file);
				
				patentApi.uploadexlec(formData).then(res => {
					// console.log(res)
					this.$message("导入成功,等待后台执行！");
					this.$refs.upload.clearFiles(); //去掉文件列表
					patentApi.plscpatent({file:res.data.url}).then(res => {
						this.$message(res.msg);
					})
				})
			},
			onErrorFile(){
			   this.$message("导入失败！");
			   this.$refs.upload.clearFiles(); //去掉文件列表
			 },
			onSuccessFile(response) {
			   // 你的代码
			   this.$message("导入成功！");
			   this.$refs.upload.clearFiles(); //去掉文件列表
			},
			zlztCheckChange(e) {
				this.loadPatentList();
			},
			sbztcheckChange(e) {
				this.loadPatentList();
			},
			zlflcheckChange(e) {
				this.loadPatentList();
			},
			ydztcheckChange(e) {
				this.loadPatentList();
			},
			// 处理排序变化
			handleSortChange({ column, prop, order }) {
				if (prop === 'guideprice') {
					if (order === 'ascending') {
						// 升序：从低到高
						this.sort_field = 'guideprice';
						this.sort_order = 'asc';
					} else if (order === 'descending') {
						// 降序：从高到低
						this.sort_field = 'guideprice';
						this.sort_order = 'desc';
					} else {
						// 取消排序
						this.sort_field = '';
						this.sort_order = '';
					}
					this.loadPatentList();
				}
			},
		searchInput() {
			// 直接发送搜索关键字到后端，支持空格和逗号分隔
			this.loadPatentList();
		},
			zlmcInput() {
				this.loadPatentList();
			},
			zlhInput() {
				this.loadPatentList();
			},
			zdjInput1(e) {
				if (this.searh_zdj2_val == '') {
					this.loadPatentList();
				} else {
					if (this.searh_zdj1_val <= this.searh_zdj2_val) {
						this.loadPatentList();
					}
				}
			},
			zdjInput2(e) {
				if (this.searh_zdj1_val == '') {
					this.loadPatentList();
				} else {
					if (this.searh_zdj1_val <= this.searh_zdj2_val) {
						this.loadPatentList();
					}
				}
			},
			// pageSize 改变时会触发
			handleSizeChange(e) {
				this.pageSize = e;
				this.loadPatentList();
			},
			// currentPage 改变时会触发
			handleCurrentChange(e) {
				this.page = e;
				this.loadPatentList();
			},
			// 预定
			sqydShow(item, index) {
				if (index == 1) {
					this.yddiaTile = '申请取消预定？';
					this.ydCancelType = 1; // 新增：取消预订
				} else if (index == 2) {
					this.yddiaTile = '申请取消排队？';
					this.ydCancelType = 2; // 新增：取消排队
				} else if (index == 3) {
					this.yddiaTile = '预定专利？';
					this.ydCancelType = 0; // 新增：新增预定
				} else if (index == 4) {
					this.yddiaTile = '排队专利？';
					this.ydCancelType = 0; // 新增：新增排队
				}
				this.yddialogItem = item;
				this.yddialogVisible = true;
			},
			closeydtc() {
				this.yddialogItem = '';
				this.ydCancelType = 0; // 新增：重置cancel_type
				this.yddialogVisible = false;
			},
			sqyd() {
				patentApi.setreserve({
					id: this.yddialogItem.id,
					cancel_type: this.ydCancelType // 新增：传递cancel_type参数
				}).then(res => {
					console.log(res)
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.closeydtc();
					this.loadPatentList();
				})
			},
			// 专利数据
			loadPatentList() {
				//类型
				var lx = '';
				this.zlztcheckList.forEach(item => {
					lx = lx + item + ","
				})
				if (lx.length > 0) {
					lx = lx.slice(0, -1);
				}
				// 高校
				var sb = '';
				this.sbztcheckList.forEach(item => {
					sb = sb + item + ","
				})
				if (sb.length > 0) {
					sb = sb.slice(0, -1);
				}
				
				// 专利分类
				var zlfl = '';
				this.zlflcheckList.forEach(item => {
					zlfl = zlfl + item + ","
				})
				if (zlfl.length > 0) {
					zlfl = zlfl.slice(0, -1);
				}
				// 状态
				var ydzt = '';
				this.ydztcheckList.forEach(item => {
					ydzt = ydzt + item + ","
				})
				if (ydzt.length > 0) {
					ydzt = ydzt.slice(0, -1);
				}
				patentApi.getpatentlist({
					page: this.page,
					pageSize: this.pageSize,
					lx: lx,
					sb: sb,
					zdj: this.searh_zdj1_val,
					zgj: this.searh_zdj2_val,
					zlname: this.searh_ly_val,
					zlh: this.searh_zlh_val,
					search: this.searval1,
					ydzt: ydzt,
					zlfl:zlfl,
					sort_field: this.sort_field,
					sort_order: this.sort_order
				}).then(res => {
					console.log(res)
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.daytotal = res.data.daycount;
				})
			},
			// 获取索引
			getIndex(index) {
				return index + 1;
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 复制专利
			copyzl() {
				if (this.multipleSelection.length == 0) {
					this.$message.error('请选择要复制的专利');
				} else {
					var text = '';
					this.multipleSelection.forEach(item => {
						if (item.type == 1) {
							text = text + '授权未缴费发明 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 2) {
							text = text + '下证发明 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 3) {
							text = text + '授权未缴费实用 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 4) {
							text = text + '下证实用 ' + item.patentnum + ' ' +  item.patentname + ' ' + item.area + ' ' + item
								.paymenttime_text + ' ' + item.guideprice + ' ' + '\n';
						} else if (item.type == 5) {
							text = text + '外观 ' + item.patentnum + ' ' + item.patentname + ' ' + item.area + ' ' + item.paymenttime_text +
								' ' + item.guideprice + ' ' + '\n';
						}
					})
					this.$copyText(text).then(
						(e) => {
							this.$message({
								message: '已成功复制到剪切板',
								type: 'success'
							});
						},
						(err) => {
							this.$message.error('复制失败');
						}
					);

				}
			},
			// 导出数据
			exportexecl() {
				var ids = '';
				if (this.multipleSelection.length > 0) {
					this.multipleSelection.forEach(item => {
						ids = ids + item.id + ',';
					})
				}
				if (ids.length > 0) {
					ids = ids.slice(0, -1);
				}
				// 专利分类
				var zlfl = '';
				this.zlflcheckList.forEach(item => {
					zlfl = zlfl + item + ","
				})
				if (zlfl.length > 0) {
					zlfl = zlfl.slice(0, -1);
				}
				//类型
				var lx = '';
				this.zlztcheckList.forEach(item => {
					lx = lx + item + ","
				})
				if (lx.length > 0) {
					lx = lx.slice(0, -1);
				}
				// 高校
				var sb = '';
				this.sbztcheckList.forEach(item => {
					sb = sb + item + ","
				})
				if (sb.length > 0) {
					sb = sb.slice(0, -1);
				}
				// 状态
				var ydzt = '';
				this.ydztcheckList.forEach(item => {
					ydzt = ydzt + item + ","
				})
				if (ydzt.length > 0) {
					ydzt = ydzt.slice(0, -1);
				}
				
			// 显示导出进度提示
			const loading = this.$loading({
				lock: true,
				text: '正在导出Excel，请稍候...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			
			patentApi.exportexecl({
				id:ids,
				lx: lx,
				sb: sb,
				zdj: this.searh_zdj1_val,
				zgj: this.searh_zdj2_val,
				zlname: this.searh_ly_val,
				zlh: this.searh_zlh_val,
				search: this.searval1,
				ydzt: ydzt,
				zlfl:zlfl,
				my:0
			},{responseType:'blob'}).then(res=>{
				loading.close();
				
				var n = new Blob([res.data],{
					type: "text/plain;charset=utf-8"
				})
				  , a = document.createElement("a")
				  , r = window.URL.createObjectURL(n);
				a.href = r,
				a.download = "专利清单.xlsx",
				document.body.appendChild(a),
				a.click(),
				document.body.removeChild(a)
				
				// 导出成功提示
				this.$message({
					message: '导出成功！提示：打开Excel后可以双击列边框自动调整列宽以获得最佳显示效果',
					type: 'success',
					duration: 5000
				});
			}).catch(err => {
				loading.close();
				this.$message.error('导出失败，请重试');
			})
			},
			// 复制文本
			copytxt(txt) {
				this.$copyText(txt).then(
					(e) => {
						this.$message({
							message: '已成功复制到剪切板',
							type: 'success'
						});
					},
					(err) => {
						this.$message.error('复制失败');
					}
				);
			},
		}
	}
</script>

<style lang="less">
	.search-box {
		width: 96%;
		margin: 30px auto 12px auto;
		background-color: #ffffff;
		border-radius: 8px;
		padding: 15px 0;

		.search-item1 {
			display: flex;

			.item-con {
				display: flex;
				margin-right: 10px;

				.searchtxt {
					width: 370px;
				}

				.item-con-tle {
					width: 110px;
					font-size: 15px;
					text-align: right;
				}

				.item-ts-tle {
					font-size: 13px;
					color: #606266;
					margin-left: 12px;
				}
			}
		}

		.check-item {
			display: flex;
			height: 40px;
			align-items: center;

			.item-con-tle {
				width: 110px;
				font-size: 15px;
				text-align: right;
			}
		}

		.fw-item {
			display: flex;
			height: 40px;
			align-items: center;

			.item-con-tle {
				width: 110px;
				font-size: 15px;
				text-align: right;
			}

			.item-con-ipt {
				width: 180px;
			}
		}
		.upload-demo{
			margin-left: 10px;
		}
	}
	
	.el-table th.el-table__cell>.cell {
		padding: 0 14px !important;
	}
	
	.con-tle-box {
		padding: 8px 20px 0 20px;
		cursor: pointer;
		display: flex;

		.popover {
			display: flex;
			align-items: center;
		}

	}

	.con-box {
		width: 96%;
		margin: 0 auto;
		background-color: #ffffff;

		:deep(.el-table__body tr:nth-child(odd)) {
			background-color: #fef0f0;
		}

		.con-zlxx {
			.con-zlxx-1 {
				font-size: 12px;
				display: flex;
				align-items: center;

				.code {
					font-size: 14px;
					font-weight: bold;
					color: #215e21;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}

				.code-a {
					font-size: 14px;
					font-weight: bold;
					color: #4d4dff;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}
			}

			.con-zlxx-2 {
				font-size: 12px;
				display: flex;
				align-items: center;

				.code {
					font-size: 14px;
					font-weight: bold;
					color: #4d4dff;
					cursor: pointer;
					vertical-align: middle;
					margin-right: 6px;
				}
			}

			.con-zlxx-3 {
				font-size: 12px;
				display: flex;
				align-items: center;
			}

			.con-zlxx-4 {
				font-size: 12px;
				display: flex;
				align-items: center;
			}
		}

		.con-sqyd {
			width: 60px;
			cursor: pointer;
			color: #ffffff !important;
			background-color: #7999e4;
			height: 25px;
			line-height: 25px;
			text-align: center;
			border-radius: 6px;
			font-size: 13px;
		}
	}

	// 分页器
	.data-pagination {
		margin-top: 30px;
		margin-bottom: 60px;
		padding: 10px 15px;
		display: flex;
		justify-content: center;

		.el-pager .number {
			background: #fff !important;
			color: #000000 !important;
			font-weight: normal !important;
		}

		.el-pager .active {
			background: #409EFF !important;
			color: #ffffff !important;
			font-weight: normal !important;
		}

		.btn-next,
		.btn-prev {
			background: #fff !important;
			color: #000000 !important;
		}
	}
</style>